/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import Immutable from 'immutable';
import moment from './moment';

const CALENDAR_START_DATE = '2024-01-01';
const sortDatestateObject = (datestateObject) => {
  let ordered = Immutable.Map();
  Object.keys(datestateObject)
    .sort()
    .forEach((key) => {
      ordered = ordered.set(key, datestateObject[key]);
    });
  return ordered.toObject();
};

export const getStateTextFromStateNumber = (number) => {
  switch (parseInt(number, 10)) {
    case 0:
      return 'contacttheowner';
    case 1:
      return 'booked';
    case 2:
      return 'unavailable';
    case 3:
      return 'enquire';
    case 5:
      return 'available';
    default:
      throw new Error(
        `Missing number out of range bookingCalendarLogic - getStateTextFromStateNumber -- ${number}`,
      );
  }
};

export const getStateNumberFromStateText = (stateText) => {
  switch (stateText) {
    case 'contacttheowner':
      return 0;
    case 'booked':
      return 1;
    case 'unavailable':
      return 2;
    case 'enquire':
      return 3;
    case 'available':
      return 5;
    default:
      throw new Error(
        `Missing number out of range bookingCalendarLogic - getStateNumberFromStateText -- ${stateText}`,
      );
  }
};

export const getDatestateObjectFromAPIList = (apiList) => {
  if (!_.isArray(apiList)) {
    throw new Error('apiList is not an array');
  }

  let list = Immutable.Map({});
  _.each(apiList, (row) => {
    list = list.set(row.date, row.state);
  });

  return sortDatestateObject(list.toObject());
};

export const getDateStateObjectFromCalendarRanges = (dateRanges) => {
  if (!_.isArray(dateRanges)) {
    throw new Error('dateRanges is not an array');
  }

  let datestateObject = Immutable.Map({});
  _.each(dateRanges, (row) => {
    const { range } = row;
    const state = getStateNumberFromStateText(row.state);

    const start = range.start.clone();
    const end = range.end.clone().subtract(1, 'days');

    const markRange = moment.range(start, end);
    for (const day of markRange.by('days')) {
      datestateObject = datestateObject.set(day.format('YYYY-MM-DD'), state);
    }
  });
  return sortDatestateObject(datestateObject.toObject());
};

export const getAPIListFromDatestateObject = (datestateObject) => {
  if (!_.isObject(datestateObject)) {
    throw new Error('datestateObject is not an object');
  }

  let list = Immutable.List([]);
  _.each(datestateObject, (state, date) => {
    const object = {
      date,
      state,
    };
    list = list.push(object);
  });
  return _.sortBy(list.toArray(), 'date');
};

export const getCalendarRangesFromDatestateObject = (datestateObject) => {
  let array = Immutable.List();

  const range = moment.range(
    moment.utc(CALENDAR_START_DATE),
    moment.utc(CALENDAR_START_DATE).add(10, 'years'),
  );

  let start = moment.utc(CALENDAR_START_DATE);
  let end;

  for (const day of range.by('days')) {
    const currentDayString = day.format('YYYY-MM-DD');
    const nextDayString = day.add(1, 'days').format('YYYY-MM-DD');

    const currentstate = datestateObject[currentDayString] || null;
    const tomorrowstate = datestateObject[nextDayString] || null;
    if (currentstate !== tomorrowstate) {
      end = nextDayString;
      if (currentstate) {
        array = array.push({
          state: getStateTextFromStateNumber(currentstate),
          range: moment.range(moment.utc(start), moment.utc(end)),
        });
      }
      start = nextDayString;
    }
  }
  return array.toArray();
};

export const getAPIListFromCalendarRanges = (dateRanges) =>
  getAPIListFromDatestateObject(getDateStateObjectFromCalendarRanges(dateRanges));

export const getCalendarRangesFromAPIList = (apiList) =>
  getCalendarRangesFromDatestateObject(getDatestateObjectFromAPIList(apiList));

export const getNewCalendarRanges = (dateRanges, range, state) => {
  let datestateObject = Immutable.fromJS(getDateStateObjectFromCalendarRanges(dateRanges));

  const newRange = moment.range(range.start.clone(), range.end.clone().subtract(1, 'days'));

  for (const day of newRange.by('days')) {
    if (!state) {
      datestateObject = datestateObject.delete(day.format('YYYY-MM-DD'));
    } else {
      datestateObject = datestateObject.set(day.format('YYYY-MM-DD'), state);
    }
  }
  const ordered = sortDatestateObject(datestateObject.toObject());
  return getCalendarRangesFromDatestateObject(ordered);
};
